/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function ThemeDark({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path stroke="currentColor" strokeWidth={1.4} d="m13.155 11.285.158-.682-.158.682a.816.816 0 0 1 .523.378c.041.076.051.137.049.178a.237.237 0 0 1-.062.142A6.901 6.901 0 1 1 6.973.86a.225.225 0 0 1 .032.19 8.3 8.3 0 0 0 6.15 10.235Z" /></svg>;
}
;